var _mask, _path, _mask2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameStatusProgress9 = function SvgIconStorygameStatusProgress9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon_storygame_status_progress_9_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.975 38.277c.29.502.934.677 1.42.362a21.001 21.001 0 1 0-22.79 0c.486.315 1.13.14 1.42-.362.29-.502.116-1.142-.37-1.46a18.9 18.9 0 1 1 20.69 0c-.486.318-.66.958-.37 1.46Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.975 38.277c.29.502.934.677 1.42.362a21.001 21.001 0 1 0-22.79 0c.486.315 1.13.14 1.42-.362.29-.502.116-1.142-.37-1.46a18.9 18.9 0 1 1 20.69 0c-.486.318-.66.958-.37 1.46Z",
    stroke: "#fff",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    mask: "url(#icon_storygame_status_progress_9_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "icon_storygame_status_progress_9_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.025 38.277c-.29.502-.934.677-1.42.362a21 21 0 1 1 30.26-8.415c-.254.52-.895.704-1.403.424-.507-.28-.689-.918-.437-1.44a18.9 18.9 0 1 0-27.37 7.61c.486.317.66.957.37 1.46Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.025 38.277c-.29.502-.934.677-1.42.362a21 21 0 1 1 30.26-8.415c-.254.52-.895.704-1.403.424-.507-.28-.689-.918-.437-1.44a18.9 18.9 0 1 0-27.37 7.61c.486.317.66.957.37 1.46Z",
    stroke: "#fff",
    strokeWidth: 4,
    mask: "url(#icon_storygame_status_progress_9_svg__b)"
  })));
};
export default SvgIconStorygameStatusProgress9;